import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useMatchMedia from 'hooks/useMatchMedia';
import OnboardingContext from '../../../../providers/Onboarding/Onboarding.context';
import { MembersDesktop } from './components/MembersDesktop';
import { MembersMobile } from './components/MembersMobile';

import './Members.styles.scss';
import './Members.styles.responsive.scss';

type MembersProps = {
  className?: string;
};

const Members: React.FC<MembersProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();
  const isTablet = useMatchMedia('isTablet');
  const { contentCard } = useContext(OnboardingContext);

  const classes = classNames('members', 'page', className);

  return (
    <div className={classes}>
      <h2>{t('dataRoomMembers')}</h2>
      <p>{t(`dataRoomMembersDescription${isTablet ? 'Mobile' : ''}`)}</p>
      {contentCard}

      {isTablet ? <MembersMobile /> : <MembersDesktop />}
    </div>
  );
};

export default Members;
